/* Argentinísimo · personalizador compacto (snippets/personalizacao-fields.liquid)
   - Barra cerrada → al abrir elige la variante "Personalizar"; "Borrar y cerrar" vuelve a "Sin personalizar".
   - Pestañas: Nombre y número / Elegí un jugador (solo si hay lista configurada).
   - Al enviar: sin datos → se compra sin personalizar; datos incompletos → se frena con un aviso. */
(function () {
  if (window.__argPerso) return;
  window.__argPerso = true;

  var ESTADO = {};
  var RE_PERS = /^personalizar$/i;
  var LETRAS = /[^A-ZÁÉÍÓÚÜÑ .'\-]/g;

  function $(r, s) { return r.querySelector(s); }
  function $$(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }
  function st(w) {
    var id = w.dataset.sectionId;
    return ESTADO[id] || (ESTADO[id] = { open: false, tab: 'propio', nombre: '', numero: '', jug: '' });
  }
  function maxChars(w) { return +w.dataset.maxChars || 12; }
  function maxNum(w) { return +w.dataset.maxNumber || 99; }

  /* ---------- jugadores: "MESSI - 10; J. ÁLVAREZ - 9" (se estampa tal cual) ---------- */
  function jugadores(w) {
    if (w._jug) return w._jug;
    w._jug = (w.dataset.players || '').split(';').map(function (t) {
      var m = t.trim().match(/^(.+?)\s*[-–]?\s*(\d{1,2})$/);
      if (!m || !m[1].trim()) return null;
      var n = m[1].replace(/\s*[-–]\s*$/, '').trim().toUpperCase();
      return { impreso: n, numero: m[2] };
    }).filter(Boolean);
    return w._jug;
  }

  /* ---------- variantes ---------- */
  function variantes(w) {
    if (!w._var) { try { w._var = JSON.parse($(w, '[data-pz-variants]').textContent); } catch (e) { w._var = []; } }
    return w._var;
  }
  function form(w) { return document.getElementById(w.dataset.form); }
  function idInput(w) { var f = form(w); return f && f.querySelector('[name="id"]'); }
  function varActual(w) {
    var i = idInput(w), id = i && +i.value;
    return variantes(w).filter(function (v) { return v.id === id; })[0];
  }
  function esPers(w, v) { return !!v && RE_PERS.test(String(v.o[+w.dataset.opt - 1] || '').trim()); }
  /* la misma variante (talle, etc.) con o sin personalizar, y con el mismo precio */
  function pareja(w, quiero) {
    var v = varActual(w), k = +w.dataset.opt - 1;
    if (!v) return null;
    if (esPers(w, v) === quiero) return v;
    return variantes(w).filter(function (u) {
      return u.p === v.p && RE_PERS.test(String(u.o[k]).trim()) === quiero &&
        u.o.every(function (o, i) { return i === k || o === v.o[i]; });
    })[0] || null;
  }
  function radiosOpcion(w) {
    var root = w.closest('product-info') || document;
    var r = $$(root, 'variant-selects input[type="radio"]').filter(function (x) { return RE_PERS.test(x.value.trim()); })[0];
    return r ? $$(root, 'variant-selects input[type="radio"]').filter(function (x) { return x.name === r.name; }) : [];
  }
  function elegirVariante(w, quiero) {
    var rs = radiosOpcion(w);
    var t = rs.filter(function (x) { return RE_PERS.test(x.value.trim()) === quiero; })[0];
    if (t && !t.checked) { t.checked = true; t.dispatchEvent(new Event('change', { bubbles: true })); return; }
    if (t) return;
    /* selector desplegable */
    var root = w.closest('product-info') || document;
    $$(root, 'variant-selects select').forEach(function (s) {
      var o = Array.prototype.filter.call(s.options, function (x) { return RE_PERS.test(x.value.trim()); })[0];
      if (!o) return;
      var d = Array.prototype.filter.call(s.options, function (x) { return RE_PERS.test(x.value.trim()) === quiero; })[0];
      if (d && s.value !== d.value) { s.value = d.value; s.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  }
  function ocultarOpcion(w) {
    radiosOpcion(w).forEach(function (r) { var fs = r.closest('fieldset'); if (fs) fs.classList.add('arg-pz-opt'); });
  }

  /* ---------- validación ---------- */
  function evaluar(w) {
    var s = st(w);
    if (!s.nombre && !s.numero) return { e: 'vacio' };
    if (s.tab === 'jugador' && s.jug !== '' && s.nombre && s.numero) return { e: 'ok' };
    if (!s.nombre.trim()) return { e: 'mal', m: 'Escribí el nombre (hasta ' + maxChars(w) + ' letras).', f: 'Nome' };
    if (!s.numero) return { e: 'mal', m: 'Escribí el número.', f: 'Número' };
    if (+s.numero > maxNum(w)) return { e: 'mal', m: 'El número tiene que ser del 0 al ' + maxNum(w) + '.', f: 'Número' };
    return { e: 'ok' };
  }

  /* ---------- pintar el estado ---------- */
  function pintar(w, conError) {
    var s = st(w), ev = evaluar(w), ok = ev.e === 'ok';
    var bar = $(w, '[data-pz-toggle]'), body = $(w, '[data-pz-body]');
    w.classList.toggle('is-open', s.open);
    w.classList.toggle('is-set', ok);
    bar.setAttribute('aria-expanded', s.open ? 'true' : 'false');
    body.hidden = !s.open;

    var hayJug = jugadores(w).length > 0;
    if (!hayJug) s.tab = 'propio';
    $$(w, '[data-pz-tab]').forEach(function (t) {
      var on = t.dataset.pzTab === s.tab;
      t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    $$(w, '[data-pz-panel]').forEach(function (p) { p.hidden = p.dataset.pzPanel !== s.tab; });

    var nIn = $(w, 'input[name="properties[Nome]"]'), numIn = $(w, 'input[name="properties[Número]"]');
    var sel = $(w, '[data-pz-select]'), tipo = $(w, '[data-pz-tipo]');
    if (nIn.value !== s.nombre) nIn.value = s.nombre;
    if (numIn.value !== s.numero) numIn.value = s.numero;
    if (sel) {
      if (sel.options.length < 2) jugadores(w).forEach(function (j, i) {
        var o = document.createElement('option'); o.value = String(i); o.textContent = j.impreso + ' - ' + j.numero; sel.appendChild(o);
      });
      sel.value = s.tab === 'jugador' ? s.jug : '';
    }
    /* solo viaja al carrito lo que corresponde */
    var activo = s.open || ok;
    nIn.disabled = numIn.disabled = !activo;
    tipo.disabled = !ok;
    tipo.value = s.tab === 'jugador' ? 'Jugador' : 'Nombre propio';

    var err = $(w, '[data-pz-err]');
    if (conError) err.textContent = ev.e === 'mal' ? ev.m : '';
    else if (ev.e !== 'mal') err.textContent = '';
    nIn.classList.toggle('is-bad', conError === true && ev.f === 'Nome');
    numIn.classList.toggle('is-bad', conError === true && ev.f === 'Número');

    var sum = $(w, '[data-pz-sum]');
    sum.hidden = !ok;
    sum.textContent = ok ? s.nombre.trim() + ' · #' + s.numero : '';
  }

  function abrir(w) {
    var s = st(w); s.open = true;
    elegirVariante(w, true);
    pintar(w);
  }
  function cerrar(w) {
    var s = st(w); s.open = false;
    if (evaluar(w).e !== 'ok') { s.nombre = ''; s.numero = ''; s.jug = ''; elegirVariante(w, false); }
    pintar(w);
  }
  function borrar(w) {
    var s = st(w);
    s.nombre = ''; s.numero = ''; s.jug = ''; s.open = false; s.tab = 'propio';
    elegirVariante(w, false);
    pintar(w);
  }

  function iniciar(w) {
    if (w.dataset.pzReady) return;
    w.dataset.pzReady = '1';
    var id = w.dataset.sectionId;
    if (!ESTADO[id] && esPers(w, varActual(w))) st(w).open = true; /* llegó con ?variant= personalizada */
    ocultarOpcion(w);
    pintar(w);
  }

  /* ---------- eventos ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-pz-toggle], [data-pz-tab], [data-pz-clear]');
    if (!t) return;
    var w = t.closest('[data-arg-pz]'); if (!w) return;
    if (t.hasAttribute('data-pz-toggle')) { st(w).open ? cerrar(w) : abrir(w); return; }
    if (t.hasAttribute('data-pz-clear')) { borrar(w); var b = $(w, '[data-pz-toggle]'); if (b) b.focus({ preventScroll: true }); return; }
    var s = st(w);
    if (s.tab === t.dataset.pzTab) return;
    s.tab = t.dataset.pzTab; s.nombre = ''; s.numero = ''; s.jug = ''; /* sin datos cruzados entre pestañas */
    pintar(w);
  });

  document.addEventListener('input', function (e) {
    var w = e.target.closest && e.target.closest('[data-arg-pz]'); if (!w) return;
    var s = st(w), el = e.target;
    if (el.name === 'properties[Nome]') {
      var pos = el.selectionStart, v = el.value.toUpperCase().replace(LETRAS, '').replace(/^\s+/, '').replace(/\s{2,}/g, ' ').slice(0, maxChars(w));
      if (v !== el.value) { el.value = v; try { el.setSelectionRange(Math.min(pos, v.length), Math.min(pos, v.length)); } catch (x) {} }
      s.nombre = v;
    } else if (el.name === 'properties[Número]') {
      var n = el.value.replace(/\D/g, '').slice(0, 2);
      if (n !== el.value) el.value = n;
      s.numero = n;
    } else return;
    pintar(w, evaluar(w).e === 'mal' && $(w, '[data-pz-err]').textContent ? true : undefined);
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-pz-select]')) return;
    var w = e.target.closest('[data-arg-pz]'), s = st(w), j = jugadores(w)[+e.target.value];
    s.jug = j ? e.target.value : '';
    s.nombre = j ? j.impreso : ''; s.numero = j ? j.numero : '';
    pintar(w);
  });

  document.addEventListener('focusout', function (e) {
    var w = e.target.closest && e.target.closest('[data-arg-pz]'); if (!w || e.target.name !== 'properties[Nome]') return;
    var s = st(w); s.nombre = s.nombre.trim(); pintar(w);
  });

  function avisar(w, msg) {
    var s = st(w); s.open = true; pintar(w, true);
    if (msg) $(w, '[data-pz-err]').textContent = msg;
    w.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var f = evaluar(w).f;
    var inp = f && $(w, 'input[name="properties[' + f + ']"]');
    if (inp) setTimeout(function () { inp.focus({ preventScroll: true }); }, 350);
  }
  function widgetsDe(f) { return $$(document, '[data-arg-pz]').filter(function (w) { return f && w.dataset.form === f.getAttribute('id'); /* f.id devuelve el <input name="id"> */ }); }

  /* "Agregar al carrito" (también lo usa la barra fija) */
  document.addEventListener('submit', function (e) {
    widgetsDe(e.target).forEach(function (w) {
      if (e.defaultPrevented) return;
      var ev = evaluar(w), i = idInput(w);
      if (ev.e === 'mal') { e.preventDefault(); e.stopImmediatePropagation(); avisar(w); return; }
      var p = pareja(w, ev.e === 'ok');
      var orig = i && i.value;
      if (i && p && String(p.id) !== i.value) i.value = p.id; /* misma variante, mismo precio */
      if (ev.e === 'vacio') {
        $$(w, 'input[name^="properties["]').forEach(function (x) { x.disabled = true; });
        st(w).open = false;
      }
      setTimeout(function () {
        if (i && orig && i.value !== orig) i.value = orig;
        pintar(w);
      }, 0);
    });
  }, true);

  /* "Comprar ahora": no pasa por el submit, revisamos antes */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.shopify-payment-button');
    if (!b) return;
    widgetsDe(b.closest('form')).forEach(function (w) {
      var ev = evaluar(w), pers = esPers(w, varActual(w));
      if (ev.e === 'mal') { e.preventDefault(); e.stopImmediatePropagation(); avisar(w); return; }
      if (ev.e === 'ok' && !pers) { e.preventDefault(); e.stopImmediatePropagation(); elegirVariante(w, true); avisar(w, 'Listo, ya quedó tu personalización. Tocá de nuevo para comprar.'); return; }
      if (ev.e === 'vacio' && pers) { e.preventDefault(); e.stopImmediatePropagation(); borrar(w); }
    });
  }, true);

  /* ---------- inicio y re-render de variantes ---------- */
  function todo() {
    $$(document, '[data-arg-pz]').forEach(function (w) { if (w.dataset.pzReady) ocultarOpcion(w); else iniciar(w); });
  }
  var pend = false;
  new MutationObserver(function () {
    if (pend) return; pend = true;
    requestAnimationFrame(function () { pend = false; todo(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todo); else todo();
})();
